import { User } from '../models';

export class SurveyCompleteUser {
    public id: number;    
    public userID: number;    
    public user: User;
    public teamID?: number;    
    public organizationID?: number;
}


// WEBPACK FOOTER //
// ./src/models/SurveyCompleteUser.tsx